export const SLOT_SIZE = "30";
export const SLOT_INTERVAL = "15";

// Glepnir rejects start_date 93+ days out, so today+92 is the last fetchable day.
export const MAX_AVAILABILITY_START_OFFSET_DAYS = 92;
